import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter, AfterViewChecked, OnChanges, SimpleChanges, OnDestroy } from '@angular/core'
import { Router, ActivatedRoute } from '@angular/router'

import { environment } from '../../../environments/environment'
@Component({
    selector: 'app-audio',
    templateUrl: './audio.component.html',
    styleUrls: ['./audio.component.scss'],
    standalone: false
})
export class AudioComponent implements OnInit, AfterViewChecked, OnChanges , OnDestroy{

  @Input('items') items
  @Input('startAt') startAt: number = 0
  @Input('currentTime') currentTime: number = 0
  @Input('question') question: string = ''
  @Input('skipToEnd') skipToEnd: boolean = false
  @Input("previewing") previewing: boolean = false

  @ViewChild('audio', { static: false }) audio: any

  @Output() endSection = new EventEmitter<{ }>()
  @Output() playedMedia = new EventEmitter<{ }>()
  @Output() startedMedia = new EventEmitter<{ }>()
  @Output() finishedMedia = new EventEmitter<{ }>()
  @Output() emitRating = new EventEmitter<{}>()


  currentObject: any = null
  showVote: boolean = false
  duration: number = 1
  progressValue: number = 0
  underPlay: boolean = false
  voted: boolean = false
  votedValue: number = 0
  autoplay: boolean = false
  mediaType: string = 'audio'
  lastUpdated: number = 0
  updateInterval: number = 1000

  qpListener = null

  constructor(private router: Router, private route: ActivatedRoute) {}

  //when component has init
  ngOnInit() {
    this.qpListener = this.route.queryParams.subscribe((queryParams) => {
      if (queryParams.autoplay) {
        this.autoplay = queryParams.autoplay === 'true'
      }


    })
  }

  ngOnDestroy(): void {
    this.qpListener.unsubscribe()
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('updated start at', this.startAt)
    this.loadNewGame()
  }

  ngAfterViewChecked() {
    //this.onPlay({underPlay: true})
  }

  //when meta data loaded
  onLoadedMetadata() {
    if (!this.lastUpdated || this.lastUpdated + this.updateInterval < Date.now()) {
      this.lastUpdated = Date.now()
      this.onMediaTimeUpdate()
    }
  }

  //when the time has updated (comes from audio component ).
  onMediaTimeUpdate() {
    this.currentTime = this.audio.nativeElement.currentTime
    if (!Number.isNaN(this.audio.nativeElement.duration)) {
      this.duration = this.audio.nativeElement.duration
    }
    this.progressValue = Math.trunc((100 * this.currentTime) / this.duration)
  }

  //called by audio component when audio has finished
  onMediaEnd() {
    this.underPlay = true
    this.showVote = true
    this.finishedMedia.emit({})
  }

  //called by audio component or automatically if autoplay set to true
  onPlay(played: { underPlay: boolean }) {
    this.underPlay = played.underPlay
    const audio = this.audio
    const playPromise = audio.nativeElement.play()
    if (playPromise){
      playPromise.then(() => {

        if( this.skipToEnd ){
          console.log('skipping')
          audio.nativeElement.currentTime = this.duration - 2
        }
        this.startedMedia.emit()
      })
      .catch(() => {
        this.underPlay = false
      })
    }
    else {
      this.startedMedia.emit()
    }
  }

  //Called by Pause mechanism and after you submit a vote
  onPause(paused: { underPlay: boolean }) {
    this.underPlay = paused.underPlay
    this.audio.nativeElement.pause()
  }

  //save vote value
  onVote(makeVote: { voted: boolean, votedPreValue: number, votedValue: number }) {
    this.voted = makeVote.voted
    this.votedValue = makeVote.votedValue

  }

  //Once you submit a vote. Pause and Go to next question
  onSubmitVote(vote) {
    this.onPause({ underPlay: this.autoplay })


    console.log('audio item %o got vote: %o ', this.currentObject.id , vote.votedValue )

    this.emitRating.emit({
      isAudio: true,
      value: vote.votedValue,
      ...this.currentObject
    })


    this.loadNewGame()

  }

  //load the first/next question
  private loadNewGame() {
    this.voted = false
    this.showVote = this.previewing
    if (this.startAt < this.items.length ) {
      if (this.startAt > 0) {
        //emit that a value has been submitted
        // this.playedMedia.emit({})
      }
      this.currentObject = this.items[this.startAt]

      this.lastUpdated = undefined
      this.audio.nativeElement.src = environment.audioBaseDir + this.currentObject.audio
      this.audio.nativeElement.load()
      if (this.autoplay) {
        const obj = this
        setTimeout(() => {
          obj.onPlay({ underPlay: true })
        }, 500)
      }
    } else if (this.startAt >= this.items.length) {
      //reached the end of the section
      this.endSection.emit()
    }
  }

}
